import React, { useEffect, useState } from "react";
import {
  getAllMatchesOddsCricketAPI,
} from "../service/cricket";
import store from "../redux/store";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { PERMISSION_MAP } from "../utils/constants";
import { getClientAPI, getUserDataAPI } from "../service/UserService";
import { useDispatch } from "react-redux";
import moment from "moment";

export default function Dashboard() {
  const navigate = useNavigate();
  const userData = store.getState().account.userData;
  const userPermissions =
    PERMISSION_MAP[userData?.userType?.toUpperCase()] || [];

  const [matches, setMatches] = useState([]);

  useEffect(() => {
    getAllMatchesOddsCricketAPI().then(({ response }) =>
      setMatches(response || [])
    );
  }, []);

  console.log("User Permissions:", matches);

  /* ------------------ LINK TREE ------------------ */

  const linkTree = {
    admin: [
      { name: "Admin", link: "/admin", class: "bg-purple", isPermission: true, enum: "ADMIN" },
      { name: "Sub Admin", link: "/sub_admin", class: "bg-warning", isPermission: true, enum: "SUB_ADMIN" },
      { name: "Master", link: "/master", class: "bg-primary", isPermission: true, enum: "MASTER" },
      { name: "Super Agent", link: "/super_agent", class: "bg-success", isPermission: true, enum: "SUPER_AGENT" },
      { name: "Agent", link: "/agent", class: "bg-warning", isPermission: true, enum: "AGENT" },
      { name: "Client", link: "/client", class: "bg-danger", isPermission: true, enum: "CLIENT" },
    ],
    cash: [
      { name: "Debit / Credit (Client)", link: "/ct/client", class: "bg-primary", isPermission: true, enum: "CLIENT" },
      { name: "Debit / Credit (Agent)", link: "/ct/agent", class: "bg-success", isPermission: true, enum: "AGENT" },
      { name: "Debit / Credit (SA)", link: "/ct/super_agent", class: "bg-warning", isPermission: true, enum: "SUPER_AGENT" },
      { name: "Debit / Credit (Master)", link: "/ct/master", class: "bg-danger", isPermission: true, enum: "MASTER" },
      { name: "Debit / Credit (Sub Admin)", link: "/ct/sub_admin", class: "bg-warning", isPermission: true, enum: "SUB_ADMIN" },
      { name: "Debit / Credit (Admin)", link: "/ct/admin", class: "bg-purple", isPermission: true, enum: "ADMIN" },
    ],
    ledger: [
      { name: "My Ledger", link: "/ledger", class: "bg-primary", isPermission: true, enum: "CLIENT" },
      { name: "Client Ledger", link: "/ledger/client", class: "bg-success", isPermission: true, enum: "AGENT" },
      { name: "Agent Ledger", link: "/ledger/agent", class: "bg-warning", isPermission: true, enum: "SUPER_AGENT" },
      { name: "Super Agent Ledger", link: "/ledger/super", class: "bg-danger", isPermission: true, enum: "MASTER" },
      { name: "Master Ledger", link: "/ledger/master", class: "bg-warning", isPermission: true, enum: "SUB_ADMIN" },
      { name: "Sub Admin Ledger", link: "/ledger/subadmin", class: "bg-purple", isPermission: true, enum: "ADMIN" },
    ],
  };

  /* ------------------ RENDER ------------------ */

  const renderLinkTreeBoxes = (treeKey) =>
    linkTree[treeKey]
      ?.filter(item => userPermissions.includes(item.enum))
      .map((item, index) => (
        <div key={item.link} className="col-lg-6 col-12">
          <a
            className={`small-box ${item.class}`}
            href={item.link}
            style={{ cursor: "pointer" }}
          >
            <div className="inner">
              <h3>{index + 1}</h3>
              <p>{item.name}</p>
            </div>
            <a
              className="small-box-footer"
              href={item.link}
            >
              More Info <i className="fas fa-arrow-circle-right" />
            </a>
          </a>
        </div>
      ));


  const roleVisibilityMap = {
    SUPER_ADMIN: "ADMIN",
    ADMIN: "SUB_ADMIN",
    SUB_ADMIN: "MASTER",
    MASTER: "SUPER_AGENT",
    SUPER_AGENT: "AGENT",
    AGENT: "CLIENT",
    Default: "Default",
  };

  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const [currentPageClient, setCurrentPageClient] = useState(0);
  const [sizeClient, setSizeClient] = useState(1000);
  const [isActive, setIsActive] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [userBalance, setUserBalance] = useState(0);

  const dispatch = useDispatch();
  const { id } = useParams();

  const location = useLocation();
  const getClient = async () => {
    // setLoading(true);
    const { response } = await getClientAPI(
      search,
      currentPage,
      sizeClient,
      id,
      id ? "" : roleVisibilityMap[userData?.userType],
      location?.state?.blocked,
      isActive != null ? isActive : null,
      id
    );
    let response_ = response;
    if (response_) {
      response_.childrenUserResponseDTOS =
        response_.childrenUserResponseDTOSPage.content.sort(
          (a, b) => a.uid - b.uid
        );
      setTotalCount(response_.totalCount);
    }
  };

  const getUserData = async () => {
    var { response, code } = await getUserDataAPI(userData.id);
    if (code === 200) {
      setUserBalance(response);
      dispatch({
        type: "accountData/setUserProfile",
        payload: response,
      });
    } else { }
  };
  useEffect(() => {
    getUserData();
    getClient();
  }, []);


  return (
    <div className="content-wrapper">
      <section className="content">
        <div className="container-fluid">

          <div className="dashboardBody mt-4">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="dashCard bg-dark-blue">
                  <h5>Chips</h5>
                  <span>
                    <span id="ContentPlaceHolder1_LBLUserChips">{Number(userData?.balance?.toFixed(2))}</span>
                  </span>
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                <div className="dashCard bg-dark-blue">
                  <h5>My Share</h5>
                  <span>
                    <span id="ContentPlaceHolder1_LBLMyShare">{userData?.partnershipAndCommission?.myPartnership}</span>
                  </span>
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                <div className="dashCard bg-dark-blue">
                  <h5>Comm</h5>
                  <span>
                    M<span id="ContentPlaceHolder1_LBLMCO">{userData?.partnershipAndCommission?.matchCommission}</span>/ S
                    <span id="ContentPlaceHolder1_LBLSCO">{userData?.partnershipAndCommission?.sessionCommission}</span>/ C
                    <span id="ContentPlaceHolder1_LBLCMCO">{userData?.partnershipAndCommission?.casinoCommission}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>


          {/* TOP DASHBOARD */}
          <div className="row">
            {[
              { id: "admin", title: `${userData?.userType} Details`, color: "bg-purple" },
              { id: "games", title: "Games", color: "bg-success" },
              { id: "cash", title: "Cash Transaction", color: "bg-warning" },
              { id: "ledger", title: "Ledger", color: "bg-danger" },
            ].map((box, i) => (
              <div
                key={box.id}
                className="col-lg-3 col-6"
                data-toggle="modal"
                data-target={`#modal-${box.id}`}
              >
                <div className={`small-box ${box.color}`}>
                  <div className="inner">
                    <h3>{i + 1}</h3>
                    <p>{box.title}</p>
                  </div>
                  <a className="small-box-footer" href={`#modal-${box.id}`}>
                    More Info <i className="fas fa-arrow-circle-right" />
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* MODALS */}
          {["admin", "cash", "ledger"].map((key) => (
            <div key={key} className="modal fade" id={`modal-${key}`}>
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-body">
                    <div className="row">{renderLinkTreeBoxes(key)}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {/* GAMES MODAL */}
          <div className="modal fade" id="modal-games">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="row">
                    <div className="col-lg-6 col-12">
                      <a className="small-box bg-primary" href="/game/inPlay">
                        <div className="inner">
                          <h3>1</h3>
                          <p>InPlay</p>
                        </div>
                        <div className="small-box-footer">
                          More Info <i className="fas fa-arrow-circle-right" />
                        </div>
                      </a>

                    </div>
                    <div className="col-lg-6 col-12">
                      <a className="small-box bg-success" href="/game/completeGame">
                        <div className="inner">
                          <h3>2</h3>
                          <p>Complete</p>
                        </div>
                        <div className="small-box-footer">
                          More Info <i className="fas fa-arrow-circle-right" />
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <section className="dashtableboday border-radias-5 border-thame-1 m-0">
            <div className="dashtableHead">
              <h4 className="tableTitle">Inplay Matches</h4>
            </div>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-cricket"
                role="tabpanel"
                aria-labelledby="pills-cricket-tab"
                tabIndex={0}
              >
                <div className="table-responsive">
                  <table className="table table-striped m-0">
                    <thead className="rounded-t">
                      <tr>
                        <th className="tracking-wider">#</th>
                        <th className="tracking-wider" />
                        <th className="tracking-wider">NAME </th>
                        <th className="tracking-wider">match DATE</th>
                        <th className="tracking-wider text-center">Details</th>
                        {/* <th class="px-2 py-1 tracking-wider">Inplay </th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {matches
                        // ?.filter((match) => match?.inPlay)
                        ?.map((match, index) => (
                          <tr className="bg-[#FFFFFF] hover:bg-[#E6FAFF] border-b border-black border-opacity-10 text-sm text-gray-600 cursor-pointer">
                            <td>{index + 1}</td>
                            <td>
                              <Link
                                className="detailbtn animated-text"
                                to={`/game/matchPosition/${match.cricketId}`} state={{ match }} >
                                {" "}
                                <svg
                                  stroke="currentColor"
                                  fill="currentColor"
                                  strokeWidth={0}
                                  viewBox="0 0 448 512"
                                  height="1em"
                                  width="1em"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z" />
                                </svg>
                              </Link>
                            </td>
                            <td>{match?.eventName}</td>
                            <td>{moment(match?.eventTime).format("DD MMM HH:mm A")}</td>
                            <td>
                              <Link
                               style={{width : '100px'}}
                                className="detailbtn text-white"
                                to={`/game/matchPosition/${match.cricketId}`} state={{ match }} >
                                {" "}
                                DETAILS
                              </Link>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          </section>


        </div>
      </section>
    </div>
  );
}
